import ClearanceCertificateSignature from './ClearanceCertificateSignature'

export default ClearanceCertificateSignature
